import React from 'react';
import PropTypes from 'prop-types';

import IconChevronDown from '@spothero/icons/chevron-down';
import IconUser from '@spothero/icons/user-circle';
import {Icon} from '@spothero/ui';

import MenuButton from '../common/MenuButton';
import MotionIcon from 'common/animation/MotionIcon';

export const menuButtonStyleProps = {
    color: 'black',
    borderColor: 'white',
    backgroundColor: 'white',
    paddingX: 4,
    paddingY: 2,
    fontWeight: 'semibold',
    fontSize: 'sm',
    _hover: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _active: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _focus: {
        boxShadow: 'outline',
    },
    sx: {
        '&.active': {
            borderColor: 'navBlue',
            backgroundColor: 'navBlue',
            color: 'primary.600',
            _hover: {
                color: 'primary.700',
            },
            _active: {
                color: 'primary.600',
                _hover: {
                    color: 'primary.700',
                },
            },
        },
    },
};

const getNavigationItemTabIconStyleProps = (isOpen) => ({
    boxSize: 2,
    marginLeft: 2,
    animate: {
        rotate: isOpen ? -180 : 0,
    },
    transition: {
        type: 'spring',
        damping: 25,
        stiffness: 180,
        duration: 0.125,
        delay: 0,
    },
});

const UserMenuButton = ({isOpen}) => {
    return (
        <MenuButton {...menuButtonStyleProps} data-testid="UserMenuButton">
            <Icon as={IconUser} boxSize={5} />
            <MotionIcon
                name="chevron-down"
                as={IconChevronDown}
                boxSize={4}
                width={4}
                height={4}
                {...getNavigationItemTabIconStyleProps(isOpen)}
            />
        </MenuButton>
    );
};

UserMenuButton.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

export default UserMenuButton;
